import styled, { keyframes } from 'styled-components';
import Media from '../../Theme/media-breackpoint';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const glow = keyframes`
  0% {
    box-shadow: 0 0 20px rgba(193, 225, 35, 0.6);
  }
  50% {
    box-shadow: 0 0 30px rgba(193, 225, 35, 0.8);
  }
  100% {
    box-shadow: 0 0 20px rgba(193, 225, 35, 0.6);
  }
`;

const CenteredContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-color: #fff;
    top: 0;
    left: 0;
    z-index: 9999;
`;

const LoaderContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
`;

const VIcon = styled.div`
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #c1e123, #5aff5a);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 32px;
    color: white;
    font-family: 'Inter', sans-serif;
    animation: ${glow} 2s ease-in-out infinite;
    ${Media.sm} {
        width: 50px;
        height: 50px;
        font-size: 28px;
    }
`;

const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 3px solid transparent;
    border-top: 3px solid #34d399;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    ${Media.sm} {
        width: 35px;
        height: 35px;
        border-width: 2px;
    }
`;

const LoadingText = styled.p`
    font-size: 18px;
    font-weight: 500;
    color: #34d399;
    font-family: 'Inter', sans-serif;
    margin: 0;
    ${Media.sm} {
        font-size: 16px;
    }
`;

const HeaderLogoBox = styled.div`
    width: 38px;
    height: 38px;
    background: linear-gradient(104.62deg, #28bd75 0%, #57db9b 100%);
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 24px;
    color: #fff;
    font-family: 'Inter', sans-serif;
    // box-shadow: 0 0 20px rgba(193, 225, 35, 0.6);
    ${Media.sm} {
        width: 32px;
        height: 32px;
        font-size: 18px;
        margin-right: 8px;
    }
`;

const Loader = () => {
    return (
        <CenteredContainer>
            <LoaderContent>
                <HeaderLogoBox>B</HeaderLogoBox>
                <LoadingSpinner />
                <LoadingText>Loading your experience...</LoadingText>
            </LoaderContent>
        </CenteredContainer>
    );
};

export default Loader;
